import { Type } from 'class-transformer';
import { Model } from './model';
import { Attachment } from './attachment';
import dayjs from 'dayjs';
import { TransformStringToDayJS } from './utils';

export enum ChatMessageStopReason {
  COMPLETED = 'completed',
  ERROR = 'error',
  MAX_TOKENS = 'max_tokens',
  USER_CANCELLED = 'user_cancelled',
}

export enum ChatMessageSenderRole {
  ASSISTANT = 'assistant',
  USER = 'user',
}

export class Chat extends Model {
  id: string;

  name: string;

  @Type(() => ChatUserMessage)
  messages: ChatUserMessage[] = [];
}

export class ChatMessage extends Model {
  id: string;

  @Type(() => Attachment)
  attachments: Attachment[];

  content: string;

  role: ChatMessageSenderRole;

  @TransformStringToDayJS()
  sent_at: dayjs.Dayjs;
}

export class ChatUserMessage extends ChatMessage {
  @Type(() => ChatAssistantMessage)
  reply: ChatAssistantMessage;
}

export class ChatAssistantMessage extends ChatMessage {
  parent_message_id: string | null;

  stop_reason: ChatMessageStopReason | null;
}
